import { render, staticRenderFns } from "./UpdatePhotoStation.vue?vue&type=template&id=68b876ce&scoped=true&"
import script from "./UpdatePhotoStation.vue?vue&type=script&lang=js&"
export * from "./UpdatePhotoStation.vue?vue&type=script&lang=js&"
import style0 from "./UpdatePhotoStation.vue?vue&type=style&index=0&id=68b876ce&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68b876ce",
  null
  
)

export default component.exports